import { useParams } from "react-router-dom"

import { LogsStream } from "../../../Plans/Templates/LogsStream";

export function Logs({ kernel }) {
    const { id } = useParams()
    return (<LogsStream kernel={kernel} deviceId={id} logType='device' url={`/dohzel/device/${id}/logs`} endpoint={`/dohzel/logs/dump?deviceId=${id}`} />)
}
